import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { TrashFill, ReplyFill } from 'react-bootstrap-icons'

const MessageFooter = ({
    onDelete = () => {},
    onReply = () => {},
    canReply
}) => {
    const iconSize = 30
    return (
        <Row style={{ padding: '10px'}}><Col>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div>
                    <Button variant='link' onClick={() => onDelete()}>
                        <TrashFill size={iconSize}/>
                    </Button>
                </div>

                <div>
                    <Button disabled={!canReply} variant='link' onClick={() => onReply()}>
                        <ReplyFill className='icon-flipped' size={iconSize + 10}/>
                    </Button>
                </div>
            </div>
        </Col></Row>
    )
}

export default MessageFooter